<a
  *ngIf="!isExternal; else external"
  [routerLink]="location"
  routerLinkActive="border-primary-color-default border-0 border-b-2"
>
  {{ label }}
</a>

<ng-template #external>
  <a [href]="location" routerLinkActive="selected">
    {{ label }}
  </a>
</ng-template>
